var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SpaceBetween',[_c('ArticleList',{attrs:{"info":_vm.info}}),_c('Rank')],1)}
var staticRenderFns = []

export { render, staticRenderFns }